import { AttachFileOutlined } from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import { isEmpty, isNil } from "lodash";
import React, { useCallback, useState } from "react";
import FilePreviewSideModal from "../../../../components/modals/FilePreviewSideModal";
import CommentAttachmentChip from "../shared/CommentAttachmentChip";

// Property Preview Items
const RenderedPreviewExistingFileItems = ({ loan, ids, onClick, onDelete }) => {
  const [file, setFile] = useState(null);

  const handleOnPreviewClick = useCallback(
    (id) => {
      console.log("click");
      const document = loan?.loanDocuments?.find((b) => b._id === id);
      setFile(document);
    },
    [loan],
  );

  const getExistingFileNameById = useCallback((loan, id) => {
    const document = loan?.loanDocuments?.find((b) => b._id === id);

    if (isNil(document)) {
      return "Unknown";
    }
    return document?.file_display_name;
  }, []);

  if (isEmpty(ids)) {
    return null;
  }
  return ids.map((id) => (
    <React.Fragment key={id}>
      <CommentAttachmentChip
        key={id}
        attachmentId={id}
        background={"#f2f9fe"}
        // background={blue[50]}
        color={blue[800]}
        icon={<AttachFileOutlined className="thin" />}
        onDelete={onDelete}
        onClick={() => handleOnPreviewClick(id)}
      >
        {getExistingFileNameById(loan, id)}
      </CommentAttachmentChip>
      <FilePreviewSideModal
        loan={loan}
        file={file}
        onClose={() => setFile(null)}
      />
    </React.Fragment>
  ));
};

export default RenderedPreviewExistingFileItems;
